export default "__VITE_ASSET__GoTofvNc__"